import React from "react";
import { Button, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import EntityStatus from "go-list/core/components/Table/components/EntityStatus";
import { OrganizationAlert } from "../../../../../../services/Api/Organization/organizationTypes";
import OrganizationAlertItem from "../OrganizationAlertItem";

interface Props {
	alerts: OrganizationAlert[];
	setShowAlertsModal: (value: boolean) => void;
}

const OrganizationAlertsCard = ({ alerts, setShowAlertsModal }: Props) => {
	const { t } = useTranslation("admin");
	const alertsStatus = alerts.find((alert) => alert.type === "DANGER") ? "DISABLED" : "WARNING";

	return (
		<Card className={`alerts-card ${alertsStatus === "DISABLED" ? "border-danger" : "border-warning"}`}>
			<Card.Body>
				<h5>
					{t("modules.organization.field.alerts.title")}
					<EntityStatus status={alertsStatus} />
				</h5>
				<div className="d-flex flex-column">
					{alerts.map((alert, index) => (
						<OrganizationAlertItem alert={alert} key={`organization-alert-${index}`} />
					))}
				</div>
				{alerts.length > 3 && (
					<Button variant="add" onClick={() => setShowAlertsModal(true)} className="w-100">
						{t("lib:common.action.show_all")} <strong>{alerts.length}</strong>
					</Button>
				)}
			</Card.Body>
		</Card>
	);
};
export default OrganizationAlertsCard;
